import React from 'react'
import { Box, Typography } from '@mui/material'
import { useParticipantActivity } from '../useParticipantActivity'
import { advancedColors, surfaces } from '../theme'
import { relativeFrom } from '../format'

const PresenceLine = ({ uid }: { uid: string }) => {
  const activity = useParticipantActivity(uid)

  if (activity.status === 'loading') {
    return null
  }

  const online = activity.status === 'online'
  let text = 'Not seen yet'
  if (online) {
    text = 'Online now'
  } else if (activity.status === 'seen') {
    text = `Last seen ${relativeFrom(activity.at) ?? '—'}`
  }

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        maxWidth: '100%',
        minWidth: 0,
        overflow: 'hidden',
        px: 1.25,
        py: 0.5,
        borderRadius: 999,
        // Green-surface masthead: accent green is the highlight, meru green is the ink.
        border: `1px solid ${online ? advancedColors.green : surfaces.green.fg}`,
        backgroundColor: online ? advancedColors.green : 'transparent',
        color: online ? advancedColors.surface : surfaces.green.fg,
      }}
    >
      <Box
        component="span"
        sx={{
          width: 8,
          height: 8,
          flexShrink: 0,
          borderRadius: '50%',
          ...(online
            ? { backgroundColor: advancedColors.surface }
            : { boxShadow: `inset 0 0 0 1.5px ${surfaces.green.fg}` }),
        }}
      />
      <Typography component="span" variant="subtitle2" noWrap sx={{ color: 'inherit' }}>
        {text}
      </Typography>
    </Box>
  )
}

export default PresenceLine
